import * as Joi from 'joi';

export const SignatorySchema = Joi.object()
  .keys({
    firstName: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'First name is required.',
      'string.base': 'First name is invalid.',
      'string.empty': 'First name is invalid.',
      'string.min': 'First name can at most be 100 characters only.',
      'string.max': 'First name can at most be 100 characters only.',
    }),
    middleName: Joi.string().trim().min(1).max(100).optional().messages({
      'string.base': 'Middle name is invalid.',
      'string.empty': 'Middle name is invalid.',
      'string.min': 'Middle name can at most be 100 characters only.',
      'string.max': 'Middle name can at most be 100 characters only.',
    }),
    hasMiddleName: Joi.boolean().required().messages({
      'any.required': 'Field is required.',
      'boolean.base': 'Field is invalid.',
    }),
    lastName: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'Last name is required.',
      'string.base': 'Last name is invalid.',
      'string.empty': 'Last name is invalid.',
      'string.min': 'Last name can at most be 100 characters only.',
      'string.max': 'Last name can at most be 100 characters only.',
    }),
    position: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'Position is required.',
      'string.base': 'Position is invalid.',
      'string.empty': 'Position is invalid.',
      'string.min': 'Position can at most be 100 characters only.',
      'string.max': 'Position can at most be 100 characters only.',
    }),
  })
  .messages({
    'object.base': 'Signatories must contain objects.',
  });
